<template>
  <div class="message-cards">
    <div class="flex overflow-x-auto pl-4 pr-2 py-4">
      <div
        v-for="(card, index) in cards"
        :key="index"
        class="card flex-shrink-0 mr-2"
        @click="openItemLink(card)"
      >
        <div
          class="card-inner relative w-full h-full"
          :style="{ backgroundImage: `url('${card.image}')` }"
        >
          <button
            v-if="card.action === ACTION_TYPE.vto"
            class="absolute px-3 py-1"
            @click.stop="$emit('try-on', { garment_id: card.data.garment_id })"
          >
            {{ $t('chat.try_on') }}
          </button>
        </div>
      </div>
    </div>
    <transition name="fade">
      <GarmentLightbox
        v-if="lightbox.isShow"
        :link="lightbox.link"
        :name="lightbox.name"
        @close="lightbox.isShow = false"
      />
    </transition>
  </div>
</template>
<script>
import GarmentLightbox from '../Lightbox/GarmentLightbox.vue';
import { ACTION_TYPE } from '../../constants';

export default {
  props: {
    message: {
      type: Object,
    },
  },
  components: {
    GarmentLightbox,
  },
  data() {
    return {
      lightbox: {
        isShow: false,
        data: {
          link: '',
          name: '',
        },
      },
      ACTION_TYPE,
    };
  },
  computed: {
    cards() {
      return this.message.content;
    },
  },
  methods: {
    // openLightbox({ link, text }) {
    //   this.lightbox.link = link;
    //   this.lightbox.name = text;
    //   this.lightbox.isShow = true;
    // },
    openItemLink({ link }) {
      window.open(link, '_blank');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/scss/animation.scss';

.message-cards {
  overscroll-behavior: none;

  .card {
    width: 150px;
    height: 150px;
    border-radius: 8px;
    background-color: var(--secondary-color);

    .card-inner {
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }

    button {
      font-size: 12px;
      line-height: 1.5;
      border-radius: 38px;
      border: 1px solid var(--primary-text);
      right: 8px;
      bottom: 8px;
      background-color: rgba(0, 0, 0, 0.6);
      outline: none;

      &:active {
        background-color: var(--primary-text);
        color: var(--primary-button-text);
      }
    }
  }
}
</style>
